import { useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useDesassociarAtividade = ({ roteiro, onChange = () => {} }) => {
  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (data) {
      toast.success("Atividade desassociada com sucesso. ");
      onChange();
    }
    if (errors) {
      toast.error(errors.message ?? "Erro durante a desassociação da atividade. ");
    }
  }, [data, errors, onChange]);

  const onRemoveHandler = useCallback(
    (atividades) => {
      const payload = {
        sequencialRoteiro: roteiro.sequencialRoteiro,
        sequencialAtividade: atividades[0].chave,
      };

      request(apiRoutes.fiscalizacao.parametrizacao.desassociarAtividadeRoteiro, payload);
    },
    [request, roteiro.sequencialRoteiro],
  );

  return {
    isLoading,
    onRemoveHandler,
  };
};

export default useDesassociarAtividade;
